export const name = 'sessionManager' as const

export const SessionManagerSymbol = Symbol('SessionManager')
export const SiteContextOtpRefreshSymbol = Symbol('SiteContextOtpRefresh')

export const sessionExportsNamespace = 'session'
